"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const epic_alt_1 = __importDefault(require("epic-alt"));
const window_or_global_1 = __importDefault(require("window-or-global"));
/**
 * Setup alt and wrap it in debugger.
 *
 * Alt is a singleton on the root window and on the server in the global scope.  this means that we need
 * to make sure that we only ever use a single instance.
 *
 * Requires this chrome extension:
 * https://github.com/goatslacker/alt-devtool
 */
let alt; //eslint-disable-line
if (typeof window_or_global_1.default['__epic-react-common-alt'] !== 'undefined') {
    alt = window_or_global_1.default['__epic-react-common-alt'];
}
else {
    alt = new epic_alt_1.default({
        // Hack for alt so that server-side we don't always have to flip to a string and back.  Our objects are already JSON
        // Data on the server, so just return that.
        deserialize(data) {
            if (typeof data === 'string') {
                return JSON.parse(data);
            }
            return data;
        }
    });
    window_or_global_1.default['__epic-react-common-alt'] = alt;
}
exports.default = alt;
//# sourceMappingURL=alt.js.map